import { hitsPerPage } from "instantsearch.js/es/widgets";
import { getInstance, registerWidget } from "./searchsync-create-instance";

function initHitsPerPageWidget() {
  const tgblAlgoliaDataJSON = window.atob(tgblSearchsyncDataEncoded);
  const tgblAlgoliaData = jQuery.parseJSON(tgblAlgoliaDataJSON);
  
  // TODO: Translations
  //const LOCALIZED = tgblAlgoliaData.localized;

  const elements = document.querySelectorAll(
    "[data-filter-type='hits-per-page']",
  );
  const elementsArray = Array.from(elements);

  // Group together elements that share an index
  const elementsGroupedByIndex = elementsArray.reduce((acc, element) => {
    const dataIndexValue = element.getAttribute("data-index");
    if (!acc[dataIndexValue]) {
      acc[dataIndexValue] = [];
    }
    acc[dataIndexValue].push(element);
    return acc;
  }, {});

  // Loop through each index
  for (const dataIndexValue in elementsGroupedByIndex) {
    if (elementsGroupedByIndex.hasOwnProperty(dataIndexValue)) {
      const elementsWithSameIndex = elementsGroupedByIndex[dataIndexValue];
      let search = getInstance(dataIndexValue);

      // Perform actions on elements with the same data-index value
      elementsWithSameIndex.forEach((element) => {
        const indexName = element.getAttribute("data-index");
        const widgetID = element.getAttribute('data-id')
        
        const itemsObject = tgblAlgoliaData[widgetID]['hits_per_page_items']
        const items = Object.values(itemsObject);
                
        if ( ! items.length ) return;
        items[0].default = true;
        const search = getInstance(indexName);

        let SearchsyncHitsPerPage = ($, search, element) => {
          search.addWidgets([
            hitsPerPage({
              container: element,
              items: items,
            }),
          ]);
          registerWidget(element);
        };
        SearchsyncHitsPerPage($, search, element);
      });
    }
  }
};

export { initHitsPerPageWidget }
  
